
import React from 'react';
import { roastLight, roastMedium, roastDark } from './text.js';
//import { imageToResolutionMobile } from '../multiFunctions.js';

function IndividualCoffeeComponents(prop) {
    let BoxStyles = {
        borderRadius: "30px",
        borderColor: "black",
        borderStyle: "solid",
        backgroundImage: "linear-gradient(to bottom, white, #8C6E63, white)",
        textAlign: "center",
        '&:hover': {
          backgroundColor: 'primary.dark',
        }
    };
    if (prop.isLargeScreen) {
        BoxStyles.width = "25%"; 
    } else if (prop.isSmallScreen) {
        BoxStyles.width = "95%";
        BoxStyles.margin = "10px";
        BoxStyles.maxWidth = "300px";
    }

    //let roastImageUrl = "";
    let roastArray = [ {url:""}, {url:""}, {url:""} ];
    let roastText = "";

    if (prop.roast === "light") {
        roastArray[0] = {url:"img/tostLevelOn.png"};
        roastArray[1] = {url:"img/tostLevelOff.png"};
        roastArray[2] = {url:"img/tostLevelOff.png"};
        roastText = roastLight;
    } else if (prop.roast === "medium") {
        roastArray[0] = {url:"img/tostLevelOn.png"};
        roastArray[1] = {url:"img/tostLevelOn.png"};
        roastArray[2] = {url:"img/tostLevelOff.png"};
        roastText = roastMedium;
    } else if (prop.roast === "dark") {
        roastArray[0] = {url:"img/tostLevelOn.png"};
        roastArray[1] = {url:"img/tostLevelOn.png"};
        roastArray[2] = {url:"img/tostLevelOn.png"};
        roastText = roastDark;
    }

    return (
        <div style={BoxStyles}>
            
            <div id={"levelRoast_" + prop.componentCount} style={{ paddingTop: "10px" }} >
                <div>
                    {
                        roastArray.map((item, index) => {
                            return <img key={prop.componentCount + index} src={item.url} height="45" alt="" />
                        })
                    }
                </div>
                <p style={{ fontSize: "xxx-large", fontVariant: "all-small-caps", margin: "0px" }}>{prop.roast}</p>
                <div style={{ padding: "5px", textAlign: "justify", marginBottom: "10px" }}>
                    <span  style={{ fontSize: "large" }}>{roastText}</span>
                </div>
            </div>
        </div>
    )
}

export default IndividualCoffeeComponents;